import React from 'react';
import { getBulletPointsText } from '../../../common/search/motor';
import type { MotorAd } from '../../../types';

type MotorBulletsProps = {
    ad: MotorAd;
    className?: string;
};

export function MotorBullets(props: MotorBulletsProps) {
    const { ad, className = '' } = props;

    const text = getBulletPointsText(ad);

    if (!text) {
        return null;
    }

    return <div className={`text-xs s-text-subtle ${className}`}>{text}</div>;
}
